import React, { useEffect } from "react";
import PropTypes from "prop-types";

import ModalPortal from "../sections/common/ModalPortal";

/**
 * SparkTG "Call initiated" confirmation. Small centred dialog surfaced
 * by useCallFlow after the /api/v1/patient-communication/initiate-call
 * endpoint returns `vendor: "sparktg"`.
 *
 * SparkTG dials the reviewer's own phone (via the mapped calling
 * number), then bridges the patient — there's no in-app UI to render
 * for the call itself, so a confirm-then-dismiss shell is the whole
 * flow. Escape / backdrop click / OK all close.
 */
const CallInitiatedDialog = ({ callingFrom, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <ModalPortal>
      <div
        className="cc-modal-backdrop"
        role="presentation"
        onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
      >
        <div
          className="cc-modal cc-call-initiated"
          role="dialog"
          aria-modal="true"
          aria-labelledby="cc-call-initiated-title"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <header className="cc-modal-head">
            <span id="cc-call-initiated-title" className="cc-modal-title">
              Call initiated
            </span>
          </header>
          <div className="cc-modal-body">
            <p>
              You'll receive a call on your phone number
              {callingFrom ? <> (<strong>{callingFrom}</strong>)</> : null}
              {" "}in a moment. Please pick up to connect with the patient.
            </p>
          </div>
          <footer className="cc-modal-foot">
            <button
              type="button"
              className="cc-modal-btn cc-modal-btn-primary"
              onClick={onClose}
            >
              OK
            </button>
          </footer>
        </div>
      </div>
    </ModalPortal>
  );
};

CallInitiatedDialog.propTypes = {
  /** "+91 XXXXX X3285" — the mapped caller number, masked for display. */
  callingFrom: PropTypes.string,
  onClose:     PropTypes.func.isRequired,
};

CallInitiatedDialog.defaultProps = {
  callingFrom: "",
};

export default CallInitiatedDialog;
